<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        MAWOP Calculator
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content class="px-0" #ct>
    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-mawop-calculator-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'casing'" class="flex justify-center border py-4 my-custom-sort-header">
                Casing
            </div>

            <div [mat-sort-header]="'miyp'" class="flex justify-center border py-4">
                MIYP (psi)
            </div>

            <div [mat-sort-header]="'mcp'" class="flex justify-center border text-center py-4">
                MCP (psi)
            </div>

            <div [mat-sort-header]="'thirtyPercentMiyp'" class="flex justify-center border text-center py-4">
                30% MIYP (psi)
            </div>

            <div [mat-sort-header]="'fiftyPercentMiyp'" class="flex border justify-center py-4">
                50% MIYP (psi)
            </div>

            <div [mat-sort-header]="'eightyPercentMiyp'" class="flex border justify-center py-4">
                80% MIYP (psi)
            </div>

            <div [mat-sort-header]="'seventyfivePercentMcp'" class="flex border justify-center py-4">
                75% MCP (psi)
            </div>

            <div [mat-sort-header]="'mawop'" class="flex border justify-center py-4">
                MAWOP (psi)
            </div>

            <div class="flex justify-center border text-center py-8">Action</div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-mawop-calculator-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{ startingIndex + i + 1 }}.
                    </div>

                    <!-- Casing -->
                    <div class="flex truncate justify-center">
                        {{ row.casing }}
                    </div>

                    <!-- MIYP -->
                    <div class="flex truncate justify-center">
                        {{ row.miyp | number:'1.0-0' }}
                    </div>

                    <!-- MCP -->
                    <div class="flex justify-center">
                        {{ row.mcp | number:'1.0-0' }}
                    </div>

                    <!-- 30% MIYP -->
                    <div class="flex justify-center">
                        {{ row.thirtyPercentMiyp | number:'1.0-0' }}
                    </div>

                    <!-- 50% MIYP  -->
                    <div class="text-center">
                        {{ row.fiftyPercentMiyp | number:'1.0-0' }}
                    </div>

                    <!-- 80% MIYP -->
                    <div class="block text-center">
                        {{ row.eightyPercentMiyp | number:'1.0-0' }}
                    </div>

                    <!-- 75% MIYP -->
                    <div class="block text-center">
                        {{ row.seventyfivePercentMcp | number:'1.0-0' }}
                    </div>

                    <!-- MAWOP -->
                    <div class="block text-center">
                        {{ (row.mawop | number:'1.0-0') || '-'  }}
                    </div>

                    <!-- Action button -->
                    <div class="flex justify-center">
                        <button class="btn btn-remove-bg" (click)="form('update', row)">
                            <mat-icon class="text-primary" svgIcon="heroicons_solid:pencil-square"></mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Close</button>
    <button class="btn btn-primary" *ngIf="!isIntermediateExist" (click)="form('create')">Add Intermediate
        Casing</button>
</mat-dialog-actions>


<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>